import {InjectionToken} from '@angular/core';
import {GlobalSearchCategory} from '../types/global-search.types';
import {FilterDefinition} from './global-search-category-config.abstract';
import {CycleCategory} from './cycle.category-config';
import {UserGroupCategory} from './user-group.category-config';
import {UserCategory} from './user.category-config';

export const CATEGORY_CONFIGS = {
	[GlobalSearchCategory.CYCLE]: new CycleCategory(),
	[GlobalSearchCategory.USER]: new UserCategory(),
	[GlobalSearchCategory.USER_GROUP]: new UserGroupCategory(),
};

export const FILTERS_CONFIG: Record<GlobalSearchCategory, FilterDefinition<any, any>[]> = {
	[GlobalSearchCategory.CYCLE]: CATEGORY_CONFIGS[GlobalSearchCategory.CYCLE].getFilters(),
	[GlobalSearchCategory.USER]: CATEGORY_CONFIGS[GlobalSearchCategory.USER].getFilters(),
	[GlobalSearchCategory.USER_GROUP]: CATEGORY_CONFIGS[GlobalSearchCategory.USER_GROUP].getFilters(),
};

// --- Injection Token (נשאר זהה) ---
export const FILTERS_CONFIG_TOKEN = new InjectionToken<typeof FILTERS_CONFIG>('FILTERS_CONFIG');
